<template>
  <tab-layout :full-width="true">
    <div slot="tabContent" class="bg-white rounded mb-4 p-3">
      <page-heading>Invoices</page-heading>

      <template v-if="!loading && !invoices.length">No invoice found.</template>

      <div v-else class="invoices_container_main">
        <div v-if="loading" class="table-overlay">
          <div class="table-spinner" />
        </div>

        <div class="invoices_table">
          <div class="invoices_table_header">
            <span>Date</span>
            <span class="invoice_draft">Draft</span>
            <span class="invoice_number">Invoice #</span>
            <span>Invoice Type</span>
            <span class="invoice_payment_type">Payment Type</span>
            <span class="invoice_paid_amount">Paid Amount</span>
            <span class="invoice_status_cell">Status</span>
            <span class="invoice_pay_cell" />
          </div>

          <invoice-row
            v-for="invoice in invoices"
            :key="invoice.id"
            :invoice="invoice"
            :generating="generatingPdfIds.has(invoice.id)"
            @pay="onPay(invoice)"
            @generate-pdf="generatePdf(invoice.id)"
          />
        </div>

        <invoice-stripe-form
          v-if="selectedInvoice != null"
          ref="stripeForm"
          :invoice="selectedInvoice"
          @close="closeStripeForm"
          @paid="onPaid"
        />
      </div>

      <pagination
        v-if="invoices.length"
        :total-pages="totalPages"
        :page="page"
        :on-change="onPageChange"
        :disabled="loading"
        class="mt-3"
      />
    </div>
  </tab-layout>
</template>

<script>
import { defineComponent, getCurrentInstance, nextTick } from '@vue/composition-api'
import TabLayout from '@/components/TabLayout'
import PageHeading from '@/components/PageHeading'
import Pagination from '@/components/Pagination'
import InvoiceRow from '@/components/Invoices/InvoiceRow'
import InvoiceStripeForm from '@/components/Invoices/InvoiceStripeForm'
import useInvoicesList from '@/composables/invoices/useInvoicesList'

export default defineComponent({
  name: 'InvoicesList',
  components: { TabLayout, PageHeading, Pagination, InvoiceRow, InvoiceStripeForm },
  setup() {
    const { proxy } = getCurrentInstance()
    const {
      invoices,
      page,
      totalPages,
      loading,
      selectedInvoice,
      fetchInvoices,
      openStripeForm,
      closeStripeForm,
      generatePdf,
      generatingPdfIds
    } = useInvoicesList()

    const initialPage = parseInt(proxy.$route.query.page, 10) || 1
    fetchInvoices(initialPage)

    function onPageChange(p) {
      if (proxy.$route.query.page !== String(p)) {
        proxy.$router.replace({ query: { ...proxy.$route.query, page: String(p) } })
      }
      fetchInvoices(p)
    }

    function onPay(invoice) {
      openStripeForm(invoice)
      nextTick(() => {
        if (proxy.$refs.stripeForm != null) {
          proxy.$refs.stripeForm.$el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        }
      })
    }

    function onPaid() {
      closeStripeForm()
      fetchInvoices(page.value)
    }

    return {
      invoices,
      page,
      totalPages,
      loading,
      selectedInvoice,
      openStripeForm,
      closeStripeForm,
      generatePdf,
      generatingPdfIds,
      onPageChange,
      onPay,
      onPaid
    }
  }
})
</script>



// WEBPACK FOOTER //
// src/views/Invoices/InvoicesList.vue